import { LoadingButton } from "@mui/lab";
import { Box, Button, Typography } from "@mui/material";
import { ReactComponent as OutlinedStatusIcon } from "../../assets/icons/outline-status-Info.svg";
import HTMLParser from "html-react-parser";

function AuthStatusBox(props) {
  const {
    title,
    body,
    buttonTitle,
    buttonAction,
    icon = OutlinedStatusIcon,
    loading,
  } = props;

  const Icon = icon;
  return (
    <Box
      sx={{
        boxShadow: (theme) => theme.shadows[2],
        width: "100%",
        p: "16px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Icon width={20} height={20} />
        <Typography variant="h5" color="grey.2" ml="8px">
          {title}
        </Typography>
      </Box>
      <Box mt={"8px"}>
        <Typography variant="h6" color="grey.3">
          {HTMLParser(body.replace(/(?:\r\n|\r|\n)/g, "<br>"))}
        </Typography>
      </Box>
      {buttonAction && (
        <Box
          sx={{
            mt: "8px",
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <LoadingButton
            loading={loading}
            size="small"
            variant="contained"
            color="primary"
            onClick={buttonAction}
            sx={{ color: "common.white" }}
          >
            {buttonTitle}
          </LoadingButton>
        </Box>
      )}
    </Box>
  );
}

export default AuthStatusBox;
